module.exports = __webpack_public_path__ + "static/media/search-active.a0814942.svg";